import React, { Component } from 'react'
import marker_red from '../../assets/images/newui/newrequestpage/marker_red.svg';
import marker_trial_purple from '../../assets/images/newui/newrequestpage/marker_trial_purple.svg';
import marker_green from '../../assets/images/newui/newrequestpage/marker_green.svg';
import marker_orange from '../../assets/images/newui/newrequestpage/marker_orange.svg';
import marker_darkblue from '../../assets/images/newui/newrequestpage/marker_darkblue.svg'
import subStatus from 'constants/SellerSubscriptionStatus';
import { Popup } from 'semantic-ui-react'

export class Marker extends Component {

    constructor(props) {
        super(props);
        this.state = {isOpen : false}
    }

    renderContent = () => {
        return <div>
            <div>{this.props.title}</div>
            <div>{this.props.phone}</div>
        </div>
    }

    onMarkerMouseOver = () => {
        if(this.props.onMarkerMouseOver){
            //this.props.onMarkerMouseOver(this.props.sellerid);
        }
        this.setState({isOpen : true})
    }
    onMarkerMouseOut = () => {
        if(this.props.onMarkerMouseOut){
            //this.props.onMarkerMouseOut(this.props.sellerid);
        }
        this.setState({isOpen : false})
    }

    onMarkerClick = () => {
        
        if(this.props.onMarkerClick){
            this.props.onMarkerClick();
        }
    }

    render() {
        let marker = marker_green;
        if(this.props.status == subStatus.IN_TRIAL){
            marker = marker_trial_purple;
        }
        else if(this.props.status == subStatus.ACTIVE){
            marker = marker_green;
        }
        else if(this.props.status == subStatus.CANCELED){
            marker = marker_darkblue;
        }
        else if(this.props.status == subStatus.COMMISSION_ONLY){
            marker = marker_orange;
        }
        else{
            marker = marker_green;
        }

        // if(this.props.seller && this.props.seller.autoKaching)
        // {
        //     marker = marker_green;
        // }
        if(this.props.seller && !this.props.seller.acceptingJobs)
        {
            marker = marker_red;
        }

        return (
            <>
                <div id={`pin_${this.props.sellerid}`}>
                    {/* <div style={{display:  (this.props.selectedSeller && this.props.sellerid == this.props.selectedSeller.sellerID) || this.state.isOpen ? "block" : "none",backgroundColor:"green" , width:"fit-content" , height:"50px" , position:"absolute" , bottom:"0px"}}>

                        {this.renderContent()}
                    </div> */}
                    <Popup open={(this.props.selectedSeller && this.props.sellerid == this.props.selectedSeller.sellerID) || this.state.isOpen} trigger={<img className="pin pin_new " src={marker} onClick={this.onMarkerClick} onMouseOver={this.onMarkerMouseOver} onMouseOut={this.onMarkerMouseOut}></img>}

                        content={this.renderContent()}
                        position='top center'
                    />
                </div>
                <div className="pulse"></div>
            </>
        )
    }


}

export default Marker
